export default __webpack_public_path__ + "static/media/product-placeholder.5b4e5f67.png";